import { Component, Input, OnChanges } from "@angular/core";
import { TimeService } from "@app2/shared/services/time.service";

@Component({
    selector: "due-date-badge",
    template: `
        <span class="due-date-badge"
              [class.is-overdue]="isOverDue && !closedOn"
              [class.was-overdue]="isOverDue && closedOn"
              [class.is-closed]="!isOverDue && closedOn">
            <tooltip-date [for]="displayClosedDate ? closedOn : dueOn"></tooltip-date>
        </span>
    `,
})
export class DueDateBadgeComponent implements OnChanges {
    @Input() dueOn: string; // ISO date
    @Input() closedOn: string; // ISO date
    @Input() displayClosedDate = false;

    isOverDue: boolean;

    constructor(private timeService: TimeService) {
    }

    ngOnChanges() {
        const startOfDay = this.timeService.now().clone().startOf("day");
        const dueOn = this.timeService.timeZoneMoment(this.dueOn);

        if (this.closedOn) {
            this.isOverDue = dueOn.isBefore(this.closedOn);
        } else {
            this.isOverDue = dueOn.isBefore(startOfDay);
        }
    }
}
